// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"b4fd612d","198":"61b2c7c9","275":"318b1a83","309":"ad60bb84","561":"f7aacd93","562":"441b64ff","762":"9bb8115f","964":"098893bd"}[chunkId] + ".chunk.js";
};